import { defineMessages } from 'dibs-react-intl';

export const messages = defineMessages({
    namePlaceholder: {
        id: 'pdpDealerDetailsMessages.name_placeholder',
        defaultMessage: 'Name',
    },
});
